import React, { useState } from 'react';

import { useTranslation } from '@crehana/i18n';

import CardLogos from 'Jsx/CheckoutV4/components/CardLogos';

import CardIssuerLogo from 'Jsx/Shared/CardIssuerLogo';

import { CreditCardIssuerType } from 'Jsx/CheckoutV4/types';

import InputField, { ChangeState, Validation } from '../../InputField';

import getCreditCardNumber from './validation/getCreditCardNumber';

export interface CreditCardNumberState {
  number: string;
  isValid: boolean;
}

interface CreditCardNumberInputProps {
  onCreditCardNumberChange: (state: CreditCardNumberState) => void;
  onIssuerChange: (issuer: CreditCardIssuerType | undefined) => void;
  autoFocus?: boolean;
}

const CreditCardNumberInput: React.FC<CreditCardNumberInputProps> = ({
  onCreditCardNumberChange,
  onIssuerChange,
  autoFocus = false,
}) => {
  const [issuer, setIssuer] = useState<CreditCardIssuerType>();
  const [length, setLength] = useState<number>(19);
  const { t } = useTranslation();

  const validateNumber = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Validation => {
    const {
      isCreditCardNumberValid,
      creditCardIssuer,
      creditCardNumberMask,
      creditCardNumberErrorMessage,
      creditCardDigitsWithBlankSpaces,
    } = getCreditCardNumber(event);

    setIssuer(creditCardIssuer);
    setLength(creditCardDigitsWithBlankSpaces);

    return {
      formattedValue: creditCardNumberMask,
      errorState: {
        message: creditCardNumberErrorMessage,
        error: !isCreditCardNumberValid,
      },
    };
  };

  const onNumberChange = ({ value, isValid }: ChangeState) => {
    onCreditCardNumberChange({ number: value, isValid });
    onIssuerChange(issuer);
  };

  return (
    <InputField
      id="credit-card-number-field"
      name="credit-card-number-field"
      testId="credit-card-number-field"
      autoComplete="cc-number"
      type="numeric"
      onChange={onNumberChange}
      validation={validateNumber}
      autoFocus={autoFocus}
      maxLength={length}
      startAdornment={<CardIssuerLogo cardType={issuer} />}
      label={
        <span className="flex items-center justify-between w-full font-subtitle3">
          <span>{t('CARD_NUMBER_LABEL')}</span>
          <CardLogos />
        </span>
      }
    />
  );
};

export default CreditCardNumberInput;
